import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#001F5F] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo Column */}
          <div>
            <img src="/assets/images/logo white blue light.webp" alt="MyBank Logo" className="mb-4" />
           
          </div>
          
          {/* About Us Column */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">{t('footer.aboutUs')}</h3>
            <ul className="space-y-2">
              <li><Link to="/who-we-are" className="text-gray-300 hover:text-[#017EFF]">{t('nav.whoWeAre')}</Link></li>
              <li><Link to="/what-drives-us" className="text-gray-300 hover:text-[#017EFF]">{t('nav.whatDrivesUs')}</Link></li>
              <li><Link to="/board-of-directors" className="text-gray-300 hover:text-[#017EFF]">{t('nav.ourBoardOfDirectors')}</Link></li>
              <li><Link to="/careers" className="text-gray-300 hover:text-[#017EFF]">{t('nav.mybankCareers')}</Link></li>
              <li><Link to="/faqs" className="text-gray-300 hover:text-[#017EFF]">{t('nav.mybankFaqs')}</Link></li>
            </ul>
          </div>

          {/* Banking Services Column */}
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-bold text-white mb-4">{t('footer.corporateBanking')}</h3>
              <ul className="space-y-2">
                <li><Link to="/personal-current-account" className="text-gray-300 hover:text-[#017EFF]">{t('nav.currentAccounts')}</Link></li>
                <li><Link to="/construction-financing" className="text-gray-300 hover:text-[#017EFF]">{t('footer.financingProducts')}</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-4">{t('footer.retailPersonalBanking')}</h3>
              <ul className="space-y-2">
                <li><Link to="/personal-current-account" className="text-gray-300 hover:text-[#017EFF]">{t('nav.accounts')}</Link></li>
                <li><Link to="/construction-financing" className="text-gray-300 hover:text-[#017EFF]">{t('footer.financingProducts')}</Link></li>
                <li><Link to="/other-services" className="text-gray-300 hover:text-[#017EFF]">{t('nav.otherServices')}</Link></li>
                <li><Link to="/evc-plus-integration" className="text-gray-300 hover:text-[#017EFF]">{t('footer.mybankAndEvcPlusIntegration')}</Link></li>
              </ul>
            </div>
          </div>

          {/* Quick Links Column */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><Link to="/news" className="text-gray-300 hover:text-[#017EFF]">{t('footer.newsAndCommunity')}</Link></li>
              <li><Link to="/gallery" className="text-gray-300 hover:text-[#017EFF]">Gallery</Link></li>
              <li><Link to="/ecommerce-api" className="text-gray-300 hover:text-[#017EFF]">{t('footer.ecommerceApi')}</Link></li>
              <li><Link to="/download-center" className="text-gray-300 hover:text-[#017EFF]">{t('footer.downloadCenter')}</Link></li>
              <li><Link to="/brochures" className="text-gray-300 hover:text-[#017EFF]">{t('footer.brochures')}</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-[#017EFF]">{t('footer.mybankServices')}</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-300 hover:text-[#017EFF]">{t('footer.privacyPolicy')}</Link></li>
              <li><Link to="/disclaimer" className="text-gray-300 hover:text-[#017EFF]">{t('footer.disclaimer')}</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-[#017EFF]">{t('footer.termsConditions')}</Link></li>
              <li><Link to="/contact-us" className="text-gray-300 hover:text-[#017EFF]">{t('nav.contact')}</Link></li>
              <li><Link to="/customer-survey" className="text-gray-300 hover:text-[#017EFF]">Customer Survey</Link></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-8 pt-4 border-t border-gray-300 flex justify-between items-center text-sm text-gray-300">
          <p>{t('footer.copyright')}</p>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer; 